import { render, staticRenderFns } from "./CertificateDataView.vue?vue&type=template&id=a07d1e52&scoped=true"
import script from "./CertificateDataView.vue?vue&type=script&lang=js"
export * from "./CertificateDataView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07d1e52",
  null
  
)

export default component.exports